<template>
  <div class="item-con">
    <div class="label-con flex flex-row align-center">
      <div class="icon" />
      <div class="label">治疗</div>
    </div>
    <div class="content">
      <el-tabs v-model="activeKey" tab-position="left" @tab-click="handleTabChange">
        <!--    饮片处方 start    -->
        <el-tab-pane label="饮片处方" name="1">
          <el-form
            ref="chmedForm"
            :model="pageData.activeDiagRecord.chmedPrescription"
            label-width="80px"
            size="small"
            :inline="true"
            :disabled="isDisabled"
          >
            <el-row>
              <el-col :span="8">
                <form-popup-item
                  v-model="pageData.activeDiagRecord.chmedPrescription.positionCode"
                  input-class-name="treatment-input"
                  :disabled="isDisabled"
                  code="positionCode"
                  name="药库编码"
                  url="clinic/inventory/inventory/position"
                  :filed-list="[
                    { code: 'id', name: 'ID' },
                    { code: 'code', name: '编码' },
                    { code: 'name', name: '名称' },
                  ]"
                  search-key="name"
                  :rules="chmedRules"
                  :searcher="{'storeCode': pageData.storeCode, positionSign: '1', classifySign: '3'}"
                  @onPopupClick="chmedPositionPopupClick"
                />
              </el-col>
              <el-col :span="8">
                <el-form-item label="药库名称">
                  <el-input
                    v-model="pageData.activeDiagRecord.chmedPrescription.positionName"
                    disabled
                    class="treatment-input"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="加工方式">
                  <el-select
                    v-model="pageData.activeDiagRecord.chmedPrescription.serveFeeSign"
                    class="treatment-input"
                  >
                    <el-option value="00" label="不加工" />
                    <el-option value="01" label="代煎" />
                    <el-option value="11" label="制粒" />
                    <el-option value="32" label="蜜丸制丸" />
                    <el-option value="33" label="大蜜丸制丸" />
                    <el-option value="34" label="浓缩丸制丸" />
                    <el-option value="35" label="水蜜丸制丸" />
                    <el-option value="41" label="制瓶装膏" />
                    <el-option value="42" label="制袋装膏" />
                    <el-option value="43" label="制块装膏" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <form-popup-item
                  v-model="pageData.activeDiagRecord.chmedPrescription.decoctionName"
                  input-class-name="treatment-input"
                  :disabled="isDisabled"
                  code="decoctionName"
                  name="煎法"
                  url="clinic/clinicdic/clinicmedicinedic/clinicmeddic"
                  :filed-list="[
                    { code: 'medDictionaryCode', name: '编码' },
                    { code: 'medDictionaryName', name: '名称' },
                  ]"
                  search-key="pinyinCode"
                  :searcher="{storeCode: pageData.storeCode, medDirectoryCode: 'JZ', effectiveSign: '1'}"
                  @onPopupClick="chmedDecoctionPopupClick"
                />
              </el-col>
              <el-col :span="8">
                <el-form-item label="总剂数">
                  <el-input-number
                    v-model="pageData.activeDiagRecord.chmedPrescription.doseNum"
                    :min="1"
                    class="treatment-input"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="次/日">
                  <el-input-number
                    v-model="pageData.activeDiagRecord.chmedPrescription.dayDoseNum"
                    class="treatment-input"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="剂/日">
                  <el-input-number
                    v-model="pageData.activeDiagRecord.chmedPrescription.dayFreq"
                    class="treatment-input"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <med-table ref="chmedTable" table-code="chmedPrescriptionItemList" :disabled="isDisabled" />
        </el-tab-pane>

        <!--    饮片处方 end    -->
        <!--    中成药处方 start    -->
        <el-tab-pane label="中成药处方" name="2">
          <el-form
            ref="medForm"
            :model="pageData.activeDiagRecord.medPrescription"
            label-width="120px"
            size="small"
            :inline="true"
            :disabled="isDisabled"
          >
            <el-row>
              <el-col :span="8">
                <form-popup-item
                  v-model="pageData.activeDiagRecord.medPrescription.positionCode"
                  input-class-name="treatment-input"
                  :disabled="isDisabled"
                  code="positionCode"
                  name="药库编码"
                  url="clinic/inventory/inventory/position"
                  :filed-list="[
                    { code: 'code', name: '编码' },
                    { code: 'name', name: '名称' },
                  ]"
                  search-key="materielName"
                  :rules="medRules"
                  :searcher="{'storeCode': pageData.storeCode, positionSign: '1', classifySign: '1'}"
                  @onPopupClick="medClincPopupClick"
                />
              </el-col>
              <el-col :span="8">
                <el-form-item label="药库名称">
                  <el-input
                    v-model="pageData.activeDiagRecord.medPrescription.positionName"
                    disabled
                    class="w-full"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <med-table ref="medTable" table-code="medPrescriptionItemList" :disabled="isDisabled" />
        </el-tab-pane>
        <!--    中成药处方 end    -->
        <!--    理疗安排 start    -->
        <el-tab-pane label="理疗安排" name="3">
          <med-table ref="serveTable" table-code="servePrescriptionItemList" :disabled="isDisabled" />
        </el-tab-pane>
        <el-tab-pane label="代煎处方" name="4">
          <el-form
            ref="chmedForm"
            :model="pageData.activeDiagRecord.djPrescription"
            label-width="80px"
            size="small"
            :inline="true"
            :disabled="isDisabled"
          >
            <el-row>
              <el-col :span="8">
                <form-popup-item
                  v-model="pageData.activeDiagRecord.djPrescription.pharmacyCode"
                  input-class-name="treatment-input"
                  code="pharmacyCode"
                  name="药房编码"
                  url="base/user/user/pharmacy"
                  :filed-list="[
                    { code: 'id', name: 'ID' },
                    { code: 'code', name: '编码' },
                    { code: 'name', name: '名称' },
                  ]"
                  search-key="name"
                  :searcher="{'storeCode': pageData.storeCode}"
                  @onPopupClick="chmedPharmacyPopupClick"
                />
              </el-col>
              <el-col :span="8">
                <el-form-item label="药房名称">
                  <el-input
                    v-model="pageData.activeDiagRecord.djPrescription.pharmacyName"
                    disabled
                    class="treatment-input"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="加工方式">
                  <el-select
                    v-model="pageData.activeDiagRecord.djPrescription.serveFeeSign"
                    class="treatment-input"
                  >
                    <el-option value="00" label="不加工" />
                    <el-option value="01" label="代煎" />
                    <el-option value="11" label="制粒" />
                    <el-option value="32" label="蜜丸制丸" />
                    <el-option value="33" label="大蜜丸制丸" />
                    <el-option value="34" label="浓缩丸制丸" />
                    <el-option value="35" label="水蜜丸制丸" />
                    <el-option value="41" label="制瓶装膏" />
                    <el-option value="42" label="制袋装膏" />
                    <el-option value="43" label="制块装膏" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="总剂数">
                  <el-input-number
                    v-model="pageData.activeDiagRecord.djPrescription.doseNum"
                    :min="1"
                    class="treatment-input"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="次/日">
                  <el-input-number
                    v-model="pageData.activeDiagRecord.djPrescription.dayDoseNum"
                    class="treatment-input"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="剂/日">
                  <el-input-number
                    v-model="pageData.activeDiagRecord.djPrescription.dayFreq"
                    class="treatment-input"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <med-table ref="djTable" table-code="djPrescriptionItemList" :disabled="isDisabled" />
        </el-tab-pane>
        <el-tab-pane label="代售处方" name="5">
          <el-form
            ref="chmedForm"
            :model="pageData.activeDiagRecord.djPrescription"
            label-width="80px"
            size="small"
            :inline="true"
            :disabled="isDisabled"
          >
            <el-row>
              <el-col :span="8">
                <form-popup-item
                  v-model="pageData.activeDiagRecord.dsPrescription.pharmacyCode"
                  input-class-name="treatment-input"
                  code="pharmacyCode"
                  name="药房编码"
                  url="base/user/user/pharmacy"
                  :filed-list="[
                    { code: 'id', name: 'ID' },
                    { code: 'code', name: '编码' },
                    { code: 'name', name: '名称' },
                  ]"
                  search-key="name"
                  :searcher="{'storeCode': pageData.storeCode}"
                  @onPopupClick="dsPharmacyPopupClick"
                />
              </el-col>
              <el-col :span="8">
                <el-form-item label="药房名称">
                  <el-input
                    v-model="pageData.activeDiagRecord.dsPrescription.pharmacyName"
                    disabled
                    class="treatment-input"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <med-table ref="dsTable" table-code="dsPrescriptionItemList" :disabled="isDisabled" />
        </el-tab-pane>
        <!--    理疗安排 end    -->
      </el-tabs>
    </div>
  </div>
</template>

<script>

import { postData } from "@/api/ik/data/dataApi"
import MedTable from "@/views/business/page/treatment/treatment/treatment/MedTable.vue"

export default {
  name: "Treatment",
  components: { MedTable },
  inject: ["pageData"],
  data() {
    return {
      activeKey: "1",
      isDisabled: false
    }
  },
  computed: {
    medRules() {
      if (this.pageData.activeDiagRecord.medPrescriptionItemList === undefined) {
        return []
      }
      return this.pageData.activeDiagRecord.medPrescriptionItemList.length > 0 ? [{
        required: true, message: "请给中成药处方选择药库编码", trigger: "change"
      }] : []
    },
    chmedRules() {
      if (this.pageData.activeDiagRecord.chmedPrescriptionItemList === undefined) {
        return []
      }
      return this.pageData.activeDiagRecord.chmedPrescriptionItemList.length > 0 ? [{
        required: true, message: "请给饮片处方选择药库编码", trigger: "change"
      }] : []
    }
  },
  watch: {
    'pageData.activeDiagRecord.treatmentRecord.executeSign': {
      handler(newVal) {
        this.isDisabled = newVal !== '1'
      },
      immediate: true
    },
    // 新增：监听饮片处方列表变化，强制刷新表格
    'pageData.activeDiagRecord.chmedPrescriptionItemList': {
      handler(newVal) {
        this.$nextTick(() => {
          if (this.$refs.chmedTable) {
            this.$refs.chmedTable.$forceUpdate()
          }
        })
      },
      deep: true
    }
  },
  methods: {
    medClincPopupClick(code, row) {
      this.pageData.activeDiagRecord.medPrescription[code] = row["code"]
      this.pageData.activeDiagRecord.medPrescription["positionName"] = row["name"]
      this.pageData.activeDiagRecord.medPrescription["positionId"] = row["id"]
    },
    chmedPositionPopupClick(code, row) {
      this.pageData.activeDiagRecord.chmedPrescription[code] = row["code"]
      this.pageData.activeDiagRecord.chmedPrescription["positionName"] = row["name"]
      this.pageData.activeDiagRecord.chmedPrescription["positionId"] = row["id"]
    },
    /**
     * 统一煎法选择：同步到所有饮片行
     */
    chmedDecoctionPopupClick(code, row) {
      this.pageData.activeDiagRecord.chmedPrescription[code] = row["medDictionaryName"]
      this.pageData.activeDiagRecord.chmedPrescription["decoctionCode"] = row["medDictionaryCode"]
      this.pageData.activeDiagRecord.chmedPrescription["decoctionId"] = row["medDictionaryId"]
      // 批量更新已有饮片行的煎法
      const list = this.pageData.activeDiagRecord.chmedPrescriptionItemList
      if (list && list.length > 0) {
        list.forEach(item => {
          item.decoctionName = row["medDictionaryName"]
          item.decoctionCode = row["medDictionaryCode"]
          item.decoctionId = row["medDictionaryId"]
        })
      }
    },
    chmedPharmacyPopupClick(code, row) {
      this.pageData.activeDiagRecord.djPrescription[code] = row["code"]
      this.pageData.activeDiagRecord.djPrescription["pharmacyName"] = row["name"]
      this.pageData.activeDiagRecord.djPrescription["pharmacyId"] = row["id"]
    },
    dsPharmacyPopupClick(code, row) {
      this.pageData.activeDiagRecord.dsPrescription[code] = row["code"]
      this.pageData.activeDiagRecord.dsPrescription["pharmacyName"] = row["name"]
      this.pageData.activeDiagRecord.dsPrescription["pharmacyId"] = row["id"]
    },
    addRow() {
      if (this.isDisabled) return
      const refMap = {
        '1': 'chmedTable',
        '2': 'medTable',
        '3': 'serveTable',
        '4': 'djTable',
        '5': 'dsTable'
      }
      const refName = refMap[this.activeKey]
      if (refName && this.$refs[refName]) {
        this.$refs[refName].addRow()
      }
    },
    handleTreatment() {
      this.$refs.chmedForm.validate(valid => {
        if (valid) {
          this.$refs.medForm.validate(medValid => {
            if (medValid) {
              const bgPath = "clinic/treatment/treatment/diagrecord/do/treatmentdiag"
              console.log(this.pageData.activeDiagRecord)
              const pd = {
                ...this.pageData.activeDiagRecord.medPrescription,
                ...this.pageData.activeDiagRecord.treatmentRecord,
                ...this.pageData.activeDiagRecord.chmedPrescription,
                code: this.pageData.activeDiagRecord.treatmentRecord.code,
                diagRecordCode: this.pageData.activeDiagRecord.diagRecord.code,
                chmedPositionId: this.pageData.activeDiagRecord.chmedPrescription["positionId"],
                chmedPositionCode: this.pageData.activeDiagRecord.chmedPrescription["positionCode"],
                chmedPositionName: this.pageData.activeDiagRecord.chmedPrescription["positionName"],
                medPositionId: this.pageData.activeDiagRecord.medPrescription["positionId"],
                medPositionCode: this.pageData.activeDiagRecord.medPrescription["positionCode"],
                medPositionName: this.pageData.activeDiagRecord.medPrescription["positionName"],
                chmedItemList: this.pageData.activeDiagRecord.chmedPrescriptionItemList,
                medItemList: this.pageData.activeDiagRecord.medPrescriptionItemList,
                serveItemList: this.pageData.activeDiagRecord.servePrescriptionItemList,
                storeCode: this.pageData.storeCode,
                storeUserCode: "CS00001SN0001"
              }
              postData(bgPath, pd)
                .then(res => {
                  this.getTreatmentRecord(res.data.code)
                  this.$message.success("诊疗完成")
                  this.$emit("command", { type: "finish" })
                })
            }
          })
        }
      })
    },
    getTreatmentdiag() {
      const pd = {
        ...this.pageData.activeDiagRecord.medPrescription,
        ...this.pageData.activeDiagRecord.treatmentRecord,
        ...this.pageData.activeDiagRecord.chmedPrescription,
        code: this.pageData.activeDiagRecord.treatmentRecord.code,
        diagRecordCode: this.pageData.activeDiagRecord.diagRecord.code,
        chmedPositionId: this.pageData.activeDiagRecord.chmedPrescription["positionId"],
        chmedPositionCode: this.pageData.activeDiagRecord.chmedPrescription["positionCode"],
        chmedPositionName: this.pageData.activeDiagRecord.chmedPrescription["positionName"],
        medPositionId: this.pageData.activeDiagRecord.medPrescription["positionId"],
        medPositionCode: this.pageData.activeDiagRecord.medPrescription["positionCode"],
        medPositionName: this.pageData.activeDiagRecord.medPrescription["positionName"],
        medItemList: this.pageData.activeDiagRecord.medPrescriptionItemList,
        serveItemList: this.pageData.activeDiagRecord.servePrescriptionItemList,
        storeCode: this.pageData.storeCode,
        storeUserCode: "CS00001SN0001"
      }
      postData("clinic/treatment/treatment/diagrecord/find/treatmentdiag", pd)
        .then(res => {
          this.getTreatmentRecord(res.data.code)
        })
    },
    handleTabChange(tab) {
      this.$emit('tab-change', tab.name)
    },
    async getTreatmentRecord(code) {
      this.pageData.diagCode = code
      const pd = {
        code: code
      }
      postData("clinic/treatment/treatment/diagrecord/find/gettreatmentrecord", pd)
        .then(async res => {
          await this.pageData.resetActiveDiagRecord()
          const responseData = res.data
          const safeMergeData = {
            ...responseData,
            chmedPrescription: responseData.chmedPrescription || {
              positionCode: "",
              positionName: "",
              doseNum: 0,
              dayDoseNum: 0,
              dayFreq: 0,
              serveFeeSign: "00",
              decoctionCode: "",
              decoctionName: ""
            },
            medPrescription: responseData.medPrescription || {
              positionCode: "",
              positionName: ""
            },
            servePrescription: responseData.servePrescription || {},
            chagentPrescription: responseData.chagentPrescription || {},
            agentPrescription: responseData.agentPrescription || {}
          }
          this.pageData.activeDiagRecord = {
            ...this.pageData.activeDiagRecord,
            ...safeMergeData
          }
          console.log(this.pageData.activeDiagRecord)
          postData('pharmacy/storage/agentpre/agentprescription/find/gettreatmentrecord', pd).then(res => {
            console.log('代煎处方返回:', res)
            if (res.data && res.data.chagentPrescription) {
              this.pageData.activeDiagRecord.djPrescription = {
                ...this.pageData.activeDiagRecord.djPrescription,
                ...res.data.chagentPrescription
              }
              this.pageData.activeDiagRecord.djPrescriptionItemList = res.data.chagentPrescriptionItemList || []
            } else {
              this.pageData.activeDiagRecord.djPrescription = this.pageData.activeDiagRecord.djPrescription || {
                pharmacyCode: "",
                pharmacyName: "",
                serveFeeSign: "00",
                doseNum: 0,
                dayDoseNum: 0,
                dayFreq: 0
              }
              this.pageData.activeDiagRecord.djPrescriptionItemList = []
            }
            if (res.data && res.data.agentPrescription) {
              this.pageData.activeDiagRecord.dsPrescription = {
                ...this.pageData.activeDiagRecord.dsPrescription,
                ...res.data.agentPrescription
              }
              this.pageData.activeDiagRecord.dsPrescriptionItemList = res.data.agentPrescriptionItemList || []
            } else {
              this.pageData.activeDiagRecord.dsPrescription = this.pageData.activeDiagRecord.djPrescription || {
                pharmacyCode: "",
                pharmacyName: "",
                doseNum: 0,
                dayDoseNum: 0
              }
              this.pageData.activeDiagRecord.dsPrescriptionItemList = []
            }
          }).catch(error => {
            console.error(error)
            this.pageData.activeDiagRecord.djPrescription = this.pageData.activeDiagRecord.djPrescription || {
              pharmacyCode: "",
              pharmacyName: "",
              doseNum: 0,
              dayDoseNum: 0
            }
            this.pageData.activeDiagRecord.djPrescriptionItemList = []
          })
        }).catch(error => {
          console.error('获取诊疗记录失败:', error)
          this.$message.error('获取诊疗记录失败')
        })
    }
  }
}
</script>
<style>
.treatment-input {
  width: 180px !important;
}
</style>
<style scoped lang="scss">
.item-con {
  .label-con {
    margin-bottom: 12px;

    .icon {
      width: 4px;
      height: 14px;
      background: #165DFF;
      border-radius: 0 0 0 0;
      margin-right: 8px;
    }

    .label {
      font-family: PingFang SC, PingFang SC, serif;
      font-weight: bold;
      font-size: 16px;
      color: #1D2129;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}

.add-btn-con {
  background: #FFFFFF;
  height: 46px;
  border: 1px solid #E5E6EB;
  padding: 7px;

  &:hover {
    cursor: pointer;
  }

  .add-btn {
    background: #F7F8FA;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #E5E6EB;

    font-family: PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 14px;
    color: #4E5969;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.treatment-input {
  width: 180px;
}
</style>
